var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoT2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38414 17.5468H0V25.9812H8.38414V17.5468Z",
    fill: "#FF3495"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0226 40.1261V35.5065C19.0226 35.4968 19.0226 35.4871 19.0226 35.4775V25.981H27.4067V17.5466H19.0226V7.99979H10.5881V35.4775C10.5881 42.6893 16.4555 48.5567 23.6673 48.5567H30.5812V40.1261H19.0245H19.0226Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3402 40.1241H32.78V48.5586H55.3402V40.1241Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9979 25.9788C55.9979 18.7089 50.0841 12.7951 42.8143 12.7951C35.5444 12.7951 29.6306 18.7089 29.6306 25.9788H38.0651C38.0651 23.3595 40.1969 21.2276 42.8162 21.2276C45.4355 21.2276 47.5673 23.3595 47.5673 25.9788C47.5673 28.5981 45.4355 30.7299 42.8162 30.7299H32.7839V39.1644H39.456L43.5204 39.145C50.4633 38.7775 55.9998 33.0146 55.9998 25.9807L55.9979 25.9788Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoT2);
export default __webpack_public_path__ + "static/media/logo-t2.b91b7e154ff509acf6e54760fb68b116.svg";
export { ForwardRef as ReactComponent };